import React from "react";
import { Row, Col, Card, Button } from "antd";
import "./index.css";
const AccountInfo = ({ companyDetails, isOpenSubcriptionModal }) => {
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Row justify="start">
          <Col
            xs={24}
            sm={24}
            md={22}
            lg={24}
            xl={24}
            style={{ border: "1px solid #eee" }}
          >
            <Card>
              <Row justify="start" gutter={[20, 20]}>
                <Col span={24}>
                  <h3 className="text-left st-cardheadingtext">
                    Account Information
                  </h3>
                </Col>
                <Col xs={10} sm={10} md={10} lg={8} xl={6} style={{ marginTop: '2rem' }} >
                  < button className="active-btn-flat text-left">Active</button>
                </Col>
                <Col xs={14} sm={14} md={14} lg={16} xl={18} style={{ marginTop: '2rem' }} >
                  <p className="account-description text-left">
                    {companyDetails?.subscription_status === "cancel_at_period_end" &&
                      `This subscription will permanently expire after ${companyDetails.subscription_period_end}.`
                    }
                    {companyDetails?.subscription_status === "ok" &&
                      ` You have subscribed for this service until ${companyDetails.subscription_period_end}. Card Used **** **** **** 4242`
                    }
                  </p>
                  <p
                    className="account-subscription pointer-cursor"
                    onClick={isOpenSubcriptionModal}
                  >
                    Manage subscription
                  </p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Col >
    </Row >
  );
};

export default AccountInfo;
